import { createApi } from '@reduxjs/toolkit/query/react'
import { baseQuery } from '../base/baseQuery'

export const userServiceApi = createApi({
  reducerPath: 'userServiceApi',
  baseQuery: baseQuery,
  tagTypes: ['User'],
  endpoints: (builder) => ({
    // Fetch all users, optionally filtered by role
    getAllUsers: builder.query({
      query: (role) =>
        role ? `/backoffice/users?role=${role}` : '/backoffice/users',
      providesTags: (result) => (result ? [{ type: 'User', id: 'LIST' }] : []),
    }),
    // Fetch a user by ID
    getUserById: builder.query({
      query: (id) => `/backoffice/users/show/${id}`,
      providesTags: (result, error, id) => [{ type: 'User', id }],
    }),
    // Invite a new user
    inviteUser: builder.mutation({
      query: (invitation) => ({
        url: '/backoffice/users/invite',
        method: 'POST',
        body: invitation,
      }),
      invalidatesTags: [{ type: 'User', id: 'LIST' }],
    }),
    // Delete a user
    deleteUser: builder.mutation({
      query: (id) => ({
        url: `/backoffice/users/delete/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: [{ type: 'User', id: 'LIST' }],
    }),
  }),
})

export const {
  useGetAllUsersQuery,
  useGetUserByIdQuery,
  useInviteUserMutation,
  useDeleteUserMutation,
} = userServiceApi
